import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

export const useStyles = makeStyles(
  (theme) => (
    {
	    chipYellow: {
        backgroundColor: '#ebeb34',
        fontWeight: '600',
      },
      chipPink: {
        backgroundColor: '#eb34ab',
        color: 'white',
        fontWeight: '600',
      },
      chipBlue: {
        backgroundColor: '#346beb',
        color: 'white',
        fontWeight: '600',
      },
      marginChip: {
        marginRight: '1px',
        marginLeft: '1px',
      },
    }
  )
);

export const AplicarLegenda = (props) => {
  const  {n1, n2, n3} = props;
  const classes = useStyles();

  return (
    <>
      <Chip size="small" label={n1 ?? 0} className={clsx(classes.chipYellow, classes.marginChip)}/>
      <Chip size="small" label={n2 ?? 0} className={clsx(classes.chipPink, classes.marginChip)}/>
      <Chip size="small" label={n3 ?? 0} className={clsx(classes.chipBlue, classes.marginChip)}/>
    </>
  );

}

export default AplicarLegenda;